import { createGesture } from './createGesture'
import { createVerificationAttempt } from './createVerificationAttempt'
import { verificationsLast } from './verificationsLast'
import { qrGenerate } from './qrGenerate'
import { qrValidate } from './qrValidate'

export default { createGesture, createVerificationAttempt, verificationsLast, qrGenerate, qrValidate }
